import React from 'react';
import { Rating } from '@pelando/components';
import StoreRatingSkeleton from './skeleton';

import { StoreRatingContainer, StoreRatingTitle } from './style';

export type StoreRatingProps = {
  title: string;
  rating: number;
  onRate: (value: number) => void;
  loading?: boolean;
};

const StoreRating = ({ title, rating, onRate, loading }: StoreRatingProps) => {
  if (loading) {
    return <StoreRatingSkeleton />;
  }

  return (
    <StoreRatingContainer>
      <StoreRatingTitle>{title}</StoreRatingTitle>
      <Rating value={rating} editable onRate={onRate} />
    </StoreRatingContainer>
  );
};

export default StoreRating;
